import { createActionCreator } from "deox";

export interface ChangeLoginErrorPayload {
  message: string;
  correlationId?: string;
}

export const changeLoginPending = createActionCreator("changeLoginPending");
export const changeLoginSuccess = createActionCreator("changeLoginSuccess");

export const changeLoginError = createActionCreator(
  "changeLoginError",
  (resolve) => (message: string, correlationId?: string) => resolve({ message, correlationId })
);
export const changeLoginInit = createActionCreator("changeLoginInit");
